///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2020 - 2020
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { createSlice } from "@reduxjs/toolkit";

import { getSupportedFiles } from "../api/attachments";

export const initialState = {
  supportedFiles: {
    isFailure: false,
    isFetching: false,
    supportedFiles: []
  },
  isForbiddenError: false
};

const appSlice = createSlice({
  name: "app",
  initialState,
  reducers: {
    requestSupportedFiles: ({ supportedFiles }) => {
      supportedFiles.isFetching = true;
      supportedFiles.isFailure = false;
    },
    receiveSupportedFilesSuccess: (state, { payload: supportedFiles }) => {
      state.supportedFiles = {
        supportedFiles,
        isFetching: false,
        isFailure: false
      };
    },
    receiveSupportedFilesFailure: ({ supportedFiles }) => {
      supportedFiles.isFetching = false;
      supportedFiles.isFailure = true;
    },
    setForbiddenError: state => {
      state.isForbiddenError = true;
    },
    clearForbiddenError: state => {
      state.isForbiddenError = false;
    }
  }
});

export const {
  requestSupportedFiles,
  receiveSupportedFilesSuccess,
  receiveSupportedFilesFailure,
  setForbiddenError,
  clearForbiddenError
} = appSlice.actions;

export const appReducer = appSlice.reducer;

export const fetchSupportedFiles = () => dispatch => {
  dispatch(requestSupportedFiles());
  getSupportedFiles()
    .then(({ data: supportedFiles }) => {
      dispatch(receiveSupportedFilesSuccess(supportedFiles));
    })
    .catch(() => {
      dispatch(receiveSupportedFilesFailure());
    });
};
